import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { classIf } from '../../data/utils/classIf';
import { getConfiguration } from '../../data/utils/configuration';
import { iconSportCssClass } from '../../data/utils/iconSportCssClass';
import { oddToString } from '../../data/utils/oddToString';
import { useFetch } from "../../data/fetch/useFetch";
import { parseWidgetData } from "../../data/parseWidgetData";
import useBetslip from "../useBetslip";
import "./SwiperCardsWh.css";
import { usePrematchData } from "../../prematch/PrematchDataProvider";

function getType(e) {
  let type = 'normal';
  try {
      const firstBet = e.bets[0];
      if (firstBet.isSuper) {
          type = 'superquota';
      } else if (firstBet.isMaggiorata) {
          type = 'maggiorata';
      }
  } catch (e) {
      console.error(e);
  }
  return type;
}

function Odd(props) {
  const odd = props.data;
  const [addBet, selected] = useBetslip(odd);
  const isHighlighted = odd.betId < 0;
  const oddClass = isHighlighted ? 'highlighted-odd' : 'regular-odd';

  return (
    <>
      {odd.value &&
        <div className={"swiper__items__content--dx" + classIf(selected, 'selected-odd')}>
          <div className="swiper__items__content--dx-title">
            {odd?.betData?.eqs?.map((e, i) => (
              e.ce == odd?.id &&
              <div className="odd_original" key={i}>{oddToString(e.qo)}</div>
            ))}
          </div>
          <div className={`swiper__items__content--dx-content ${oddClass}`} onClick={addBet}>
            <div className="icon__ctaSvg">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
                <path
                  fill="#00143c" strokeWidth="0"
                  d="m0,6C0,2.58,2.51,0,6,0s6,2.58,6,6-2.51,6-6,6S0,9.42,0,6Zm5.12,3.1c0-1.21.35-2.5,1.25-3.43l1.35,1.82v-.29c0-1.75.1-3.5.28-5.21-1.73.11-4.01.54-5.5,1.54l1.59.5c-.59.82-.83,1.82-.83,2.82,0,1.61.73,3.39,2.11,3.75-.17-.39-.24-1.07-.24-1.5h0Z" />
              </svg>
            </div>
            <div className="highlight-odd" >
              <span>{odd.value}</span>
            </div>
          </div>
        </div>
      }
    </>
  );
}

export const SwiperCardsWh = () => {
  const conf = getConfiguration();
  const prematchData = usePrematchData();

  const [isLoading, isError, data] = useFetch(conf.api.getWidgetCentrali, null, (data) =>
    parseWidgetData(data, false)
  );


  if (isLoading || isError || data?.highlights == null) {
    return null;
  }

  const highlights = data.highlights.events

  function formatDate(dataToFormat) {
    const datePart = dataToFormat.split(' ')[0];
    const year = datePart.substring(0, 4);
    const month = datePart.substring(4, 6);
    const day = datePart.substring(6, 8);
    return `${day}/${month}/${year.substring(2)}`;
  }

  return (
    <>
      <Swiper
        slidesPerView={1.1}
        spaceBetween={16}
        modules={[Pagination]}
        className="swiper__items swiper__maggiorate"
      >
        {highlights.map((e, index) => {
          const sport = prematchData.sportById[e.sportRef];
          const icoSport = iconSportCssClass(sport.id, sport.iconClass);

          e.bets = e.bets.filter(b => b.hasOdds);
          if (e.bets.length === 0) {
            return null;
          }

          return (
            <SwiperSlide key={index}>
              <div className="swiper__items--wrapper" data-type={getType(e)}>
                <div className="swiper__items--header">
                  <div className={`icona-sport ico-sport ico-highlights img-fluid ${icoSport}`}></div>
                  {e.title}
                </div>
                <div className="swiper__items__content--wrapper">
                  <div className="swiper__items__content--sx">
                    <div className="swiper__items__content--pretitle">
                      {e.topDisclaimer} - {formatDate(e.timestampDB)}
                    </div>
                    <div className="swiper__items__content--title">
                      {" "}
                      {e.midDisclaimer}
                    </div>
                    <div className="swiper__items__content--subtitle">
                      {e.bottomDisclaimer}
                    </div>
                  </div>
                  {e.bets.map((bets, betsIndex) => (
                    <React.Fragment key={betsIndex}>
                      {bets.odds.map((odds, oddsIndex) => (
                        <Odd key={oddsIndex} data={odds} />
                      ))}
                    </React.Fragment>
                  ))}
                </div>
              </div>{" "}
            </SwiperSlide>
          )
        })}
      </Swiper>
    </>
  );
};

export default SwiperCardsWh;
